import 'reflect-metadata';
import { ILogger } from './LoggerService';
import { injectable } from 'inversify-props';
import { inject } from 'inversify';
import { IEventBus } from './EventService';

declare const window: any;

/** Defines a contract for displaying notifications */
export interface INotification {

	/**
	 * Displays a success notification with the specified message
	 * @param message The message to display.
	 */
	success(message: string): void;

	/**
	 * Displays a warning notification with the specified message
	 * @param message The message to display.
	 */
	warning(message: string): void;

	/**
	 * Displays an error notification with the specified message
	 * @param message The message to display.
	 */
	error(message: string): void;

	/** Displays a notification when a feature is not yet implemented */
	notImplemented(): void;

	/** Displays a notification when a feature is not yet implemented */
	validationMessage(): void;

}

/** Displays notification messages to the user. */
@injectable()
export class NotificationService implements INotification {


	/** Event bus that's used to fire and handle global events across the application. */
	@inject('IEventBus')
	protected eventBus: IEventBus;

	/** Creates a new instance of this object. */
	constructor(@inject('ILogger') private logger: ILogger) { }

	/**
	 * Displays a success notification with the specified message
	 * @param message The message to display.
	 */
	public success(message: string): void {
		this.logger.log(`[NOTICE] Displaying success notice: ${message}`);
		this.eventBus.$emit('notification', message, 'green');
		// window.noty.success(message);
	}

	/**
	 * Displays a warning notification with the specified message
	 * @param message The message to display.
	 */
	public warning(message: string): void {
		this.logger.log(`[NOTICE] Displaying warning notice: ${message}`);
		this.eventBus.$emit('notification', message, 'orange');
		// window.noty.warning(message);
	}

	/**
	 * Displays an error notification with the specified message
	 * @param message The message to display.
	 */
	public error(message: string): void {
		this.logger.log(`[NOTICE] Displaying error notice: ${message}`);
		this.eventBus.$emit('notification', message, 'red');
		// window.noty.error(message);
	}

	/** Displays a notification when a feature is not yet implemented */
	public notImplemented(): void {
		this.logger.log(`[NOTICE] Displaying not implemented notice`);
		this.eventBus.$emit('notification', `This feature is not yet implemented`, 'orange');
	}

	/** Displays a notification when a feature is not yet implemented */
	public validationMessage(): void {
		this.logger.log(`[NOTICE] Displaying validation message`);
		this.eventBus.$emit('notification', `Please fill out all required fields`, 'orange');
	}

}
